/**
 * <dogscan-daten> — grows the butterfly bar fills when scrolled into view.
 * CSS drives the widths from each fill's --w; this just toggles `is-in`.
 * Respects reduced-motion. INSTALL: upload to the theme's assets/.
 */
if (!customElements.get('dogscan-daten')) {
  const REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

  class DogscanDaten extends HTMLElement {
    connectedCallback() {
      const grows = Array.from(this.querySelectorAll('[data-grow]'));
      if (!grows.length) return;
      if (REDUCE) { grows.forEach((g) => g.classList.add('is-in')); return; }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          setTimeout(() => e.target.classList.add('is-in'), 140);
          io.unobserve(e.target);
        });
      }, { threshold: 0.32 });
      grows.forEach((g) => io.observe(g));
    }
  }
  customElements.define('dogscan-daten', DogscanDaten);
}
